import { useEffect, useState } from 'react';
import { useAppSelector } from '../store';
import { API_BASE_URL } from '../lib/utils';

/** Fetches VAPID key only — registration happens via mdtSession after permissions gate. */
export function usePushSubscription() {
  const { token } = useAppSelector((state) => state.auth);
  const [vapidReady, setVapidReady] = useState(false);

  useEffect(() => {
    if (!token) return;
    fetch(`${API_BASE_URL}/push/vapid-public-key`)
      .then((res) => res.json())
      .then((data) => setVapidReady(!!data.publicKey))
      .catch(() => setVapidReady(false));
  }, [token]);

  return { vapidReady };
}
